const validateField = (value) => {
  const whitelistRegex = /^[a-zA-Z]+(?:\.[a-zA-Z]+)*$/;

  return whitelistRegex.test(value || "");
};

const validateFileExtension = (file, allowedTypes = []) => {
  const fileExtension = file.name.split(".").pop();
  return fileExtension && allowedTypes.includes(fileExtension);
};

export { validateField, validateFileExtension };
